import { LoadableAfterPaint } from '@confluence/loadable';

export const ContentReportTableMacroHandler = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ContentReportTableMacro" */ '../src/ContentReportTableMacroRenderer.tsx'
			)
		).ContentReportTableMacroRenderer,
});
